module.exports = __webpack_public_path__ + "static/media/tutorial_begin.ef56d8f0.png";